var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Artist Management" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex justify-between items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "search artist name" },
                                on: { change: _vm.searchArtist },
                                model: {
                                  value: _vm.filter,
                                  callback: function($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: { label: "Apply" },
                            on: { clicked: _vm.searchArtist }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "p-2" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "sync"] },
                                on: { click: _vm.resetArtist }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          label: "Add Artist",
                          variant: "outline-primary"
                        },
                        on: { clicked: _vm.addArtist }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableArtist",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [_vm.displayingItem]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom"
                        }
                      })
                    }),
                    _vm._v(" "),
                    !_vm.isFinance
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            "min-width": "100px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        scope.row.email_verified_at === null &&
                                        scope.row.statusCode == 0
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Resend Email",
                                                  position: "is-right"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mb-2 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.resendEmail(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "envelope-square"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "See Detail",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "inline-block p-2 w-8 mb-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                attrs: {
                                                  href:
                                                    "/#/artists/detail/" +
                                                    scope.row.id +
                                                    (scope.row.statusCode == 3
                                                      ? "?fromDraft=1"
                                                      : "")
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: { icon: ["fa", "eye"] }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.statusCode !== 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Block",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mb-2 mr-2 rounded bg-red-700 hover:bg-red-800 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.blockArtist(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "ban"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.statusCode === 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Unblock",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 mb-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.unBlockArtist(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "circle-notch"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Delete",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            !_vm.isOps && !_vm.isFinance
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "w-8 mr-2 mb-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteArtist(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1487663360
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b947ac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b947ac2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Artists.vue
// module id = null
// module chunks = 